"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var Menu = function Menu(props) {
  return _react["default"].createElement("svg", {
    width: props.width,
    viewBox: "0 0 18 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "menu-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "menu-title"
  }, "Menu"), _react["default"].createElement("desc", null, "Menu Button"), _react["default"].createElement("g", {
    stroke: "none",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-289.000000, -26.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(286.000000, 20.000000)"
  }, _react["default"].createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), _react["default"].createElement("path", {
    d: "M3,18 L21,18 L21,16 L3,16 L3,18 Z M3,13 L21,13 L21,11 L3,11 L3,13 Z M3,6 L3,8 L21,8 L21,6 L3,6 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
};

var _default = Menu;
exports["default"] = _default;